import apiService from "./BaseApi";
import store from "@/store/index";

const ENDPOINT = "sectors";

const currentUserPayload = () => ({
  currentUserId: store.state.currentUser?.uid,
});

/** Remove ids que o servidor define ou que vão na URL */
const stripIdsForPatch = (data) => {
  if (!data || typeof data !== "object") return {};
  const { id_doc, idDoc, id, ...rest } = data;
  return rest;
};

const SectorsService = {
  /** POST /sectors/findAll — data: array de setores */
  getSectors: async () => {
    const response = await apiService.post(`${ENDPOINT}/findAll`, {
      ...currentUserPayload(),
    });
    return response.data.data;
  },

  /** Alias legado para remover Firebase da tela de Alertas */
  getSectorsByUnitId: async (unit_id) => {
    const response = await apiService.post(`${ENDPOINT}/findByUnit`, {
      ...currentUserPayload(),
      unit_id,
    });
    return response.data.data;
  },

  /** POST /sectors/findByUnit — data: array de setores */
  findByUnit: async (unit_id) =>
    apiService.post(`${ENDPOINT}/findByUnit`, {
      ...currentUserPayload(),
      unit_id,
    }),

  /** POST /sectors/findByModem */
  findByModem: async (modem_id) =>
    apiService.post(`${ENDPOINT}/findByModem`, {
      ...currentUserPayload(),
      modem_id,
    }),

  /** POST /sectors */
  createSector: async (data) =>
    apiService.post(ENDPOINT, {
      ...currentUserPayload(),
      ...stripIdsForPatch(data),
    }),

  /** PATCH /sectors/:id */
  updateSector: async (id, data) =>
    apiService.patch(`${ENDPOINT}/${encodeURIComponent(id)}`, {
      ...currentUserPayload(),
      ...stripIdsForPatch(data),
    }),

  /** DELETE /sectors/:id — body obrigatório com currentUserId */
  deleteSector: async (id) =>
    apiService.delete(`${ENDPOINT}/${encodeURIComponent(id)}`, {
      data: currentUserPayload(),
    }),

  /** DELETE /units/:unitId/sectors */
  deleteSectorsByUnit: async (unitId) =>
    apiService.delete(
      `units/${encodeURIComponent(unitId)}/sectors`,
      { data: currentUserPayload() }
    ),
};

export default SectorsService;
